module.exports = __webpack_public_path__ + "img/welcome.svg";